import {
  CONFIG_FETCH_REQUEST,
  CONFIG_FETCH_SUCCESS,
  CONFIG_FETCH_FAILURE,
  CONFIG_CLEAR_CACHE,
} from "../types/configTypes";

const initialState = {
  loading: false,
  options: null,
  error: null,
  lastFetched: null,
};

const configReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONFIG_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CONFIG_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        options: action.payload,
        error: null,
        lastFetched: Date.now(),
      };

    case CONFIG_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CONFIG_CLEAR_CACHE:
      return {
        ...state,
        options: null,
        lastFetched: null,
      };

    default:
      return state;
  }
};

export default configReducer;
